// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSingleColumn_root__18CaG","layoutWrapperMain":"LayoutSingleColumn_layoutWrapperMain__2_MB3"};